import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Notifications from 'react-notification-system-redux';

class Notification extends PureComponent {
  render() {
    const {notifications} = this.props;
    //Optional styling
    /* const style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '5px 5px 2px 1px',
          
        },
        error: { // Applied only to the success notification item
          
        }
      }
    }; */

    return (
      <Notifications
        notifications={notifications}
        // style={style}
      />
    );
  }
}

Notification.propTypes = {
  notifications: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
};

export default connect(
  state => ({ notifications: state.notifications })
)(Notification);
